//@ts-nocheck
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {UsersListHeader} from './components/header/UsersListHeader'
import {UsersTable} from './table/UsersTable'
import {UserEditModal} from './user-edit-modal/UserEditModal'
import {KTCard} from '../../../../../_metronic/helpers'
import {useState} from 'react'

const UsersList = () => {
  const {itemIdForUpdate} = useListView()
  const [userSearch, setUserSearch] = useState('')
  const [sDate, setSDate] = useState('')
  const [eDate, setEDate] = useState('')
  const [page, setPage] = useState(1)
  return (
    <>
      <KTCard>
        <UsersListHeader
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
        />
        <UsersTable
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
        />
      </KTCard>
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const UsersListWrapper = () => <UsersList />

export {UsersListWrapper}
